<template>
  <div class="footer">

    <div class="logo">
      <img src="../assets/logo-footer.png">
      <p class="copy">京ICP备18003512号-2</p>
    </div>
  </div>
</template>

<script>
  export default {
      data(){
          return{

          }
      }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .footer{
    padding: 0 .4rem;

    .logo{
      margin: .2rem 0;
      img{
        width: 3.2rem;
        height: 1.6rem;
        display: block;
        margin: 0 auto;
      }
      .copy{
        text-align: center;
        color: #999;
        font-size: .12rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue